import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "../config";
import { user } from "./actions_helper";
import {
    CREATE_CALENDAR_EVENT_TYPE,
    DELETE_CALENDAR_EVENT_TYPE,
    GET_CALENDAR_EVENT_TYPES,
    UPDATE_CALENDAR_EVENT_TYPE,
} from "./types";

export function getCalendarEventTypes() {
    return (dispatch: IDispatch<any>) => {
        axios
            .get(`${API_URL}/calendar_event_types.json`, {
                headers: { authorization: user().token },
            })
            .then((response) => {
                dispatch({
                    type: GET_CALENDAR_EVENT_TYPES,
                    payload: response.data,
                });
            });
    };
}

export function createCalendarEventType(type: ICalendarEventType) {
    return (dispatch: IDispatch<any>) =>
        axios
            .post(
                `${API_URL}/calendar_event_types.json`,
                {
                    calendar_event_type: type,
                },
                { headers: { authorization: user().token } }
            )
            .then((response) => {
                const data = response.data;
                dispatch({
                    payload: data,
                    type: CREATE_CALENDAR_EVENT_TYPE,
                });
            })
            .catch((err) => {
                throw err;
            });
}

export function updateCalendarEventType(type: ICalendarEventType) {
    return (dispatch: IDispatch<any>) =>
        axios
            .patch(
                `${API_URL}/calendar_event_types/${type.id}.json`,
                {
                    calendar_event_type: type,
                },
                { headers: { authorization: user().token } }
            )
            .then((response) => {
                dispatch({
                    payload: response.data,
                    type: UPDATE_CALENDAR_EVENT_TYPE,
                });
            })
            .catch((err) => {
                throw err;
            });
}

export function deleteCalendarEventType(type: ICalendarEventType) {
    return (dispatch: IDispatch<IReduxAction<any>>) =>
        axios
            .delete(`${API_URL}/calendar_event_types/${type.id}.json`, {
                headers: { authorization: user().token },
            })
            .then((response) => {
                dispatch({
                    payload: response.data,
                    type: DELETE_CALENDAR_EVENT_TYPE,
                });
                // toast.success("Das Event wurde erfolgreich gelöscht", { autoClose: 2000 });
                // dispatch(push("/calendar"));
            })
            .catch((err) => {
                toast.error("Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut", {
                    autoClose: 3000,
                });
                throw err;
            });
}
